import React, {Component} from 'react';
import DebounceInput from "react-debounce-input";
import { injectIntl, defineMessages } from 'react-intl'

const messages = defineMessages({
    "isNot": {
        id: "common.search_filter.operation.isNot",
        defaultMessage: "is not",
    },
    "contains": {
        id: "common.search_filter.operation.contains",
        defaultMessage: "contains",
    },
    "doesNotContains": {
        id: "common.search_filter.operation.doesNotContains",
        defaultMessage: "does not contains",
    },
    "startWith": {
        id: "common.search_filter.operation.startWith",
        defaultMessage: "start with",
    },
    "endWith": {
        id: "common.search_filter.operation.endWith",
        defaultMessage: "end with",
    },
    "is": {
        id: "common.search_filter.operation.is",
        defaultMessage: 'is',
    },
})

class TextFilter extends Component{
    constructor(props,context){
        super(props,context);
        this.state={
            operation:props.op || "is",
            value:props.value || "",
        }

        this.onChangeInputFilter=this.onChangeInputFilter.bind(this);
        this.onChangeSelectOp=this.onChangeSelectOp.bind(this);
    }

    onChangeInputFilter(event) {
        this.setState({value:event.target.value})
        if(event.target.value!=""){
            this.props.onChangeValues("add",this.props.id,event.target.value,event.target.value,this.state.operation)
        }else{
            this.props.onChangeValues("remove",this.props.id,"")
        }
    }

    onChangeSelectOp(event){
        let aux=event.target.value.split("-")
        this.setState({operation:aux[1], value:""})
        this.props.onChangeValues("remove",this.props.id,"")
    }

    render(){
        return (
            <div className="panel panel-default card">
                <select
                    className="form-control mb-2"
                    name="operation-select"
                    value={this.props.id+"-"+this.state.operation}
                    onChange={this.onChangeSelectOp}
                    id={this.props.id+"-op"}
                >
                    <option value={this.props.id+"-is"}>{this.props.intl.formatMessage(messages["is"])}</option>
                    <option value={this.props.id+"-isNot"}>{this.props.intl.formatMessage(messages["isNot"])}</option>
                    <option value={this.props.id+"-contains"}>{this.props.intl.formatMessage(messages["contains"])}</option>
                    <option value={this.props.id+"-doesNotContains"}>{this.props.intl.formatMessage(messages["doesNotContains"])}</option>
                    <option value={this.props.id+"-startWith"}>{this.props.intl.formatMessage(messages["startWith"])}</option>
                    <option value={this.props.id+"-endWith"}>{this.props.intl.formatMessage(messages["endWith"])}</option>

                </select>

                <DebounceInput
                    onKeyPress={e => {
                        const code = e.keyCode || e.charCode
                        if (code === 13) { return }
                        this.setState({ loading: true })
                    }}
                    minLength={0}
                    debounceTimeout={500}
                    autoComplete="off"
                    name="searchKeywords"
                    value={this.state.value}
                    onChange={this.onChangeInputFilter}
                    id="searchKeywords"
                    type="search"
                    className="form-control"

                />

            </div>

        );
    }
}
export default injectIntl(TextFilter);


// WEBPACK FOOTER //
// ./src/common/search-filter/filters-type/types/textFilter.component.jsx